'use client';

import { useEffect, useState } from 'react';

import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { CacheProvider } from '@chakra-ui/next-js';
import { getAppLayoutContent } from 'services/client/repositories/content';
import { AppLayoutContextProvider } from 'context/appLayoutContent';
import { baseTheme } from 'styles/theme';
import RootLayout from './layout';
import { Error } from './components/Error';

export default function GlobalErrorPage() {
  const [layoutContent, setLayoutContent] = useState<AppLayoutContent | null>(
    null,
  );

  useEffect(() => {
    const fetchLayoutContent = async () => {
      const content = await getAppLayoutContent();

      setLayoutContent(content);
    };

    fetchLayoutContent();
  }, []);

  if (!layoutContent) return null;

  return (
    <RootLayout>
      <CacheProvider>
        <ChakraProvider theme={extendTheme(baseTheme)}>
          <AppLayoutContextProvider appLayoutContent={layoutContent}>
            <Error />
          </AppLayoutContextProvider>
        </ChakraProvider>
      </CacheProvider>
    </RootLayout>
  );
}
